
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_zd5ut_145",
  "scrolling-background": "awsui_scrolling-background_hyvsj_zd5ut_148",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_zd5ut_159",
  "drawers-container": "awsui_drawers-container_hyvsj_zd5ut_172",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_zd5ut_183",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_zd5ut_204",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_zd5ut_209",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_zd5ut_247",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_zd5ut_257",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_zd5ut_262",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_zd5ut_276",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_zd5ut_262",
  "drawer": "awsui_drawer_hyvsj_zd5ut_172",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_zd5ut_307",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_zd5ut_316",
  "drawer-content": "awsui_drawer-content_hyvsj_zd5ut_307",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_zd5ut_325",
  "drawer-slider": "awsui_drawer-slider_hyvsj_zd5ut_328",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_zd5ut_336",
  "content": "awsui_content_hyvsj_zd5ut_362",
  "layout": "awsui_layout_hyvsj_zd5ut_387",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_zd5ut_425",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_zd5ut_440",
  "content-type-table": "awsui_content-type-table_hyvsj_zd5ut_454",
  "content-type-cards": "awsui_content-type-cards_hyvsj_zd5ut_454",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_zd5ut_467",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_zd5ut_470",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_zd5ut_507",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_zd5ut_510",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_zd5ut_528",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_zd5ut_531",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_zd5ut_531",
  "has-header": "awsui_has-header_hyvsj_zd5ut_531",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_zd5ut_546",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_zd5ut_546",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_zd5ut_572",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_zd5ut_575",
  "has-split-panel": "awsui_has-split-panel_hyvsj_zd5ut_595",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_zd5ut_595",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_zd5ut_603",
  "unfocusable": "awsui_unfocusable_hyvsj_zd5ut_608",
  "container": "awsui_container_hyvsj_zd5ut_618",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_zd5ut_646",
  "is-tools-open": "awsui_is-tools-open_hyvsj_zd5ut_649",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_zd5ut_649",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_zd5ut_649",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_zd5ut_649",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_zd5ut_662",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_zd5ut_679",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_zd5ut_683",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_zd5ut_687",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_zd5ut_691",
  "navigation-container": "awsui_navigation-container_hyvsj_zd5ut_700",
  "show-navigation": "awsui_show-navigation_hyvsj_zd5ut_738",
  "animating": "awsui_animating_hyvsj_zd5ut_763",
  "showButtons": "awsui_showButtons_hyvsj_zd5ut_1",
  "navigation": "awsui_navigation_hyvsj_zd5ut_700",
  "openNavigation": "awsui_openNavigation_hyvsj_zd5ut_1",
  "animated-content": "awsui_animated-content_hyvsj_zd5ut_829",
  "content-container": "awsui_content-container_hyvsj_zd5ut_832",
  "hide-navigation": "awsui_hide-navigation_hyvsj_zd5ut_841",
  "notifications": "awsui_notifications_hyvsj_zd5ut_851",
  "has-notification-content": "awsui_has-notification-content_hyvsj_zd5ut_856",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_zd5ut_860",
  "high-contrast": "awsui_high-contrast_hyvsj_zd5ut_865",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_zd5ut_883",
  "position-bottom": "awsui_position-bottom_hyvsj_zd5ut_914",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_zd5ut_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_zd5ut_965",
  "position-side": "awsui_position-side_hyvsj_zd5ut_980",
  "tools-container": "awsui_tools-container_hyvsj_zd5ut_1002",
  "tools": "awsui_tools_hyvsj_zd5ut_1002",
  "openTools": "awsui_openTools_hyvsj_zd5ut_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_zd5ut_1095",
  "hide-tools": "awsui_hide-tools_hyvsj_zd5ut_1105",
  "show-tools": "awsui_show-tools_hyvsj_zd5ut_1117",
  "has-tools-form": "awsui_has-tools-form_hyvsj_zd5ut_1095",
  "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_zd5ut_1199",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_zd5ut_1215",
  "trigger": "awsui_trigger_hyvsj_zd5ut_1199",
  "selected": "awsui_selected_hyvsj_zd5ut_1267",
  "badge": "awsui_badge_hyvsj_zd5ut_1287",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_zd5ut_1291",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_zd5ut_1302",
  "dot": "awsui_dot_hyvsj_zd5ut_1306",
  "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_zd5ut_1319"
};
  